import React from "react";
import Helmet from "react-helmet";
import Header from "./header";
import Footer from "./footer"
import {Link} from "react-router-dom"
function About(){
    return (
        <div>
    <Header/>
 <section className="page-title centred" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1515526764876-0f3b298ee4ac?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80'}}>
  <div className="auto-container">
    <div className="content-box">
      <div className="title">
        <h1>Elements</h1>
      </div>
      <ul className="bread-crumb clearfix">
        <li>
            <Link to="/">Home</Link>
        </li>
        
      </ul>
    </div>
  </div>
</section>

<section className="agency-section sec-pad-2" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1616922446456-575069ed35b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60)'}}>
  <div className="auto-container">
    <div className="row align-items-center clearfix">
      <div className="col-lg-6 col-md-12 col-sm-12 content-column">
        <div className="content_block_2">
          <div className="content-box">
            <div className="sec-title light">
              <p>Learn About Agency</p>
              <h2>We’re Reliable &amp; Cost Efficiant  Agency</h2>
            </div>
            
          </div>
        </div>
      </div>
      <div className="col-lg-6 col-md-12 col-sm-12 content-column">
        <div className="content_block_3">
          <div className="content-box">
            <div className="tabs-box">
              <div className="tab-btn-box">
                
              </div>
              <div className="tabs-content">
                <div className="tab active-tab" id="tab-1">
                  <div className="inner-box">
                   
                    <div className="text">
                      <p>There are many simply free text available variations of passages of but the majority have in some.</p>
                      <ul className="list clearfix">
                        <li>Support on hiring employeers</li>
                        <li>Get rxceptional service for growth</li>
                        <li>Outsourced consulting business</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="tab" id="tab-2">
                  <div className="inner-box">
                    <figure className="image-box"><img src="https://images.unsplash.com/photo-1616922446456-575069ed35b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60" alt /></figure>
                    <div className="text">
                      <p>There are many simply free text available variations of passages of but the majority have in some.</p>
                      <ul className="list clearfix">
                        <li>Support on hiring employeers</li>
                        <li>Get rxceptional service for growth</li>
                        <li>Outsourced consulting business</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<Footer/>
        </div>
    )
}
export default About;